import React, { useState } from "react";
import logo from "../../resource/7.png";
import useFormHandler from "../../Hook/useFormHandler";

const OnGoingRequest = () => {
  const initialValues = {
    // Personal Information
    first_name: "",
    last_name: "",
    
    // Address Information
    address: "",
    city: "",
    postal_code: "",
    
    // Contact Information
    mobile_number: "",
    phone_with_country_code: "",
    email_address: "",
    
    // Project Details
    work_types: "",
    number_of_volunteers: "",
    preferred_time: "",
    requires_accommodation: "",
    
    ip_address: ""
  };

  const validations = {
    // Personal Information
    first_name: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "First Name should contain only letters, spaces, or hyphens",
    },
    last_name: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "Last Name should contain only letters, spaces, or hyphens",
    },
    
    // Address Information
    address: {
      required: true,
      minLength: 5,
      message: "Address must be at least 5 characters long",
    },
    city: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "City should contain only letters, spaces, or hyphens",
    },
    postal_code: {
      required: true,
      pattern: /^\d{5,10}$/,
      message: "Postal Code should be 5 to 10 digits",
    },
    
    // Contact Information
    mobile_number: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "Mobile Number should be 10 to 15 digits, with optional '+'",
    },
    phone_with_country_code: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "Phone number should be 10 to 15 digits, with optional '+'",
    },
    email_address: {
      required: true,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Invalid email format",
    },
    
    // Project Details
    work_types: {
      required: true,
      minLength: 10,
      message: "Please describe the work types in at least 10 characters",
    },
    number_of_volunteers: {
      required: true,
      pattern: /^\d+$/,
      message: "Number of volunteers must be a valid number",
      validate: (value) => {
        const numValue = Number(value);
        return (numValue > 0 && numValue <= 100) || "Number of volunteers must be between 1 and 100";
      },
    },
    preferred_time: {
      required: true,
      minLength: 5,
      message: "Please specify your preferred time",
    },
    requires_accommodation: {
      required: true,
      validate: (value) => value !== "" || "Please select whether you require accommodation",
    },
  };

  const endpoint = '/create-ongoing-project-requests';

  const transformForApi = (data) => ({
    // Personal Information
    first_name: data.first_name,
    last_name: data.last_name,
    
    // Address Information
    address: data.address,
    city: data.city,
    postal_code: data.postal_code,
    
    // Contact Information
    mobile_number: data.mobile_number,
    phone_with_country_code: data.phone_with_country_code,
    email_address: data.email_address,
    
    // Project Details
    work_types: data.work_types,
    number_of_volunteers: Number(data.number_of_volunteers),
    preferred_time: data.preferred_time,
    requires_accommodation: data.requires_accommodation === "true",
    
    ip_address: data.ip_address,
  });

  const {
    formData,
    errors,
    loading,
    handleInputChange,
    handleSubmit,
    setFormData,
  } = useFormHandler({
    initialValues,
    validations,
    endpoint,
    includeIP: true,
    transformFn: transformForApi
  });

  return (
    <div className="form-page dark-gold">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="Monastery Logo" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">Ongoing Projects Request Form</h2>
          </div>
        </div>

        <p className="font-p mt-5">
          Welcome to Bhaddheka Vihari Monastery Ongoing Development Activities.
        </p>
        <p className="font-p mt-4">
          Use the following form to fill your details.
        </p>
        
        <p className="font-p mt-5">Full Name*</p>
        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="text"
              id="first_name"
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
            />
            <label htmlFor="first_name">First Name</label>
            {errors.first_name && <span className="error">{errors.first_name}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
            />
            <label htmlFor="last_name">Last Name</label>
            {errors.last_name && <span className="error">{errors.last_name}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Address*</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
            <label htmlFor="address">Full Address</label>
            {errors.address && <span className="error">{errors.address}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
            />
            <label htmlFor="city">City*</label>
            {errors.city && <span className="error">{errors.city}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="postal_code"
              name="postal_code"
              value={formData.postal_code}
              onChange={handleInputChange}
            />
            <label htmlFor="postal_code">Postal Code*</label>
            {errors.postal_code && <span className="error">{errors.postal_code}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="mobile_number"
              name="mobile_number"
              value={formData.mobile_number}
              onChange={handleInputChange}
            />
            <label htmlFor="mobile_number">Mobile Number*</label>
            {errors.mobile_number && <span className="error">{errors.mobile_number}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="phone_with_country_code"
              name="phone_with_country_code"
              value={formData.phone_with_country_code}
              onChange={handleInputChange}
            />
            <label htmlFor="phone_with_country_code">Phone Number* (including country code)</label>
            {errors.phone_with_country_code && <span className="error">{errors.phone_with_country_code}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="email"
              id="email_address"
              name="email_address"
              value={formData.email_address}
              onChange={handleInputChange}
            />
            <label htmlFor="email_address">Email Address*</label>
            {errors.email_address && <span className="error">{errors.email_address}</span>}
          </div>
        </div>

        <p className="font-p mt-5">
          Please indicate the type of work you or your team can contribute in
          support of the ongoing activities at the Monastery (e.g. painting,
          electrical work, plumbing, carpentry etc.)*
        </p>

        <div className="form-item mt-4">
          <textarea
            id="work_types"
            name="work_types"
            value={formData.work_types}
            onChange={handleInputChange}
            rows="6"
          />
          {errors.work_types && <span className="error">{errors.work_types}</span>}
        </div>

        <p className="font-p mt-5">
          Please indicate how many volunteers would like to support the ongoing
          activities at the Monastery.*
        </p>

        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="number"
              id="number_of_volunteers"
              name="number_of_volunteers"
              value={formData.number_of_volunteers}
              onChange={handleInputChange}
              min="1"
              max="100"
            />
            <label htmlFor="number_of_volunteers">Number of Volunteers</label>
            {errors.number_of_volunteers && <span className="error">{errors.number_of_volunteers}</span>}
          </div>
        </div>

        <p className="font-p mt-5">
          Please indicate the time you wish to support doing these activities.*
        </p>

        <div className="form-item mt-4">
          <textarea
            id="preferred_time"
            name="preferred_time"
            value={formData.preferred_time}
            onChange={handleInputChange}
            rows="4"
          />
          {errors.preferred_time && <span className="error">{errors.preferred_time}</span>}
        </div>

        <p className="font-p mt-5">
          Please indicate whether you or your team require accommodation
          arrangements during your stay at the Monastery.*
        </p>

        <div className="selection mt-4">
          <div className="checkbox-box">
            <label htmlFor="accommodation_yes">Yes</label>
            <input
              type="radio"
              id="accommodation_yes"
              name="requires_accommodation"
              value="true"
              checked={formData.requires_accommodation === "true"}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="accommodation_no">No</label>
            <input
              type="radio"
              id="accommodation_no"
              name="requires_accommodation"
              value="false"
              checked={formData.requires_accommodation === "false"}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {errors.requires_accommodation && <span className="error">{errors.requires_accommodation}</span>}

        <button
          type="submit"
          id="submitbtn"
          className="mt-5"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
        
        <p className="font-p mt-5">
          We look forward to facilitating your request and are grateful for
          choosing Bhaddheka Vihari Monastery as an enriching space for practicing
          mindfulness meditation.
        </p>
      </form>
    </div>
  );
};

export default OnGoingRequest;